import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, Outlet } from 'react-router-dom';
import { Skeleton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import api from '@utils/axiosInstance';
import dayjs from 'dayjs';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';

import VideoListPagination from '@components/services/csmsmedia/vodManage/common/VideoListPagination';

import { secondsToFormattedTime } from '@utils/secondsToFormattedTime';
import '@resources/assets/styles/video.scss';

function VideoListContainer(props) {
    const { t } = useTranslation();

    const navigate = useNavigate();

    const cdn = useSelector(state => state.organization.cdn);
    const organizationData = useSelector(state => state.organization.organizationData);
    const userToken = useSelector(state => state.organization.userToken);

    const [isLoading, setIsLoading] = useState(false);
    const [videoListCount, setVideoListCount] = useState(0);
    const [currentVodList, setCurrentVodList] = useState([])
    const [currentPage, setCurrentPage] = useState(1);
    const [imageLoadStatus, setImageLoadStatus] = useState({});

    useEffect(() => {
        setIsLoading(true);

        // 페이지가 바뀔 때 스크롤을 맨 위로 올림
        window.scrollTo(0, 0);

        api({
            method: 'post',
            url: '/vod/getVodList',
            data: {
                userToken: userToken,
                page: currentPage,
                organizationCode: organizationData.organization_code
            }
        })
            .then((response) => {
                if (response.data.statusCode == 100) {
                    setIsLoading(false);
                    setVideoListCount(response.data.vodList.count);
                    setCurrentVodList(response.data.vodList.rows);
                }
            })
            .catch((error) => {
                console.log(error);
            });

    }, [currentPage])


    const goToDetailPage = (uuid) => {
        navigate(`/vod/${uuid}`);
    };

    const handleImageLoad = (id) => {
        setImageLoadStatus(prevState => ({
            ...prevState,
            [id]: true
        }));
    };

    return (
        <>
            <TableContainer className="container-video-list">
                <Table className="table-video-list">
                    <TableHead>
                        <TableRow>
                            <TableCell>{t('vod.manage.video')}</TableCell>
                            <TableCell>{t('vod.manage.filename')}</TableCell>
                            <TableCell>{t('vod.manage.created_at')}</TableCell>
                            <TableCell>{t('vod.manage.play_time')}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {isLoading
                            ? [...Array(5)].map((_, index) => (
                                <TableRow className="tr-video-list" key={index}>
                                    <TableCell className='td-video-list-thumbnail'>
                                        <Skeleton variant="rectangular" width={180} height={100} style={{ margin: '0 auto', backgroundColor: '#ddd' }} />
                                    </TableCell>
                                    <TableCell className='td-video-list-content'>
                                        <Skeleton variant="text" width="70%" height={20} style={{ margin: '0 auto', backgroundColor: '#ddd' }} />
                                    </TableCell>
                                    <TableCell className='td-video-list-createAt'>
                                        <Skeleton variant="text" width="70%" height={20} style={{ margin: '0 auto', backgroundColor: '#ddd' }} />
                                    </TableCell>
                                    <TableCell className='td-video-list-playTime'>
                                        <Skeleton variant="text" width="70%" height={20} style={{ margin: '0 auto', backgroundColor: '#ddd' }} />
                                    </TableCell>
                                </TableRow>
                            ))
                            : currentVodList.length > 0
                                ? currentVodList.map((el) => (
                                    <TableRow
                                        key={el.id}
                                        className="tr-video-list"
                                        onClick={() => goToDetailPage(el.uuid)}
                                    >
                                        <TableCell className='td-video-list-thumbnail'>
                                            <div className="img-video-list-thumbnail">
                                                {!imageLoadStatus[el.id] && (
                                                    <Skeleton variant="rect" width={180} height={100} style={{ margin: '0 auto' }} />
                                                )}
                                                <img
                                                    src={cdn ? `${cdn}/${el.uuid}/thumbnail/tn_1.png` : ''}
                                                    alt="Thumbnail"
                                                    onLoad={() => handleImageLoad(el.id)}
                                                    style={{
                                                        display: imageLoadStatus[el.id] ? 'block' : 'none',
                                                        width: '100%',
                                                        objectFit: 'cover'
                                                    }}
                                                />
                                            </div>
                                        </TableCell>
                                        <TableCell className='td-video-list-content'>
                                            <div className='title-video-list' style={{ wordBreak: 'break-all' }}>{el.realFileName}</div>
                                        </TableCell>
                                        <TableCell className='td-video-list-createAt'>
                                            {dayjs(el.createdAt).format("YYYY-MM-DD HH:mm:ss")}
                                        </TableCell>
                                        <TableCell className='td-video-list-playTime'>
                                            {secondsToFormattedTime(el.playTime)}
                                        </TableCell>
                                    </TableRow>
                                ))
                                : (
                                    <TableRow>
                                        <TableCell colSpan={4} style={{ textAlign: 'center', padding: '20px' }}>
                                            등록된 비디오가 없습니다.
                                        </TableCell>
                                    </TableRow>
                                )
                        }
                    </TableBody>
                </Table>
            </TableContainer>
            {!isLoading && currentVodList.length > 0 && (
                <VideoListPagination
                    videoListCount={videoListCount}
                    paginate={setCurrentPage}
                    currentPage={currentPage}
                />
            )}
        </>
    );
}

export default VideoListContainer;
